import React, { useContext, useEffect, useState } from 'react';
import { Box, ButtonGroup } from '@chakra-ui/react';
import LinkButton from '../../../components/custom/LinkButton';
import PageHeader from '../../../components/common/PageHeader';
import AddSelfTechnologyForm from '../../../components/forms/technology/AddSelfTechnologyForm';
import { UserInfoContext } from '../../../provider/UserInfoProvider';
import { UseApi } from '../../../libraries/UseApi';
import { UseMessage } from '../../../libraries/UseMessage';

export default function AddSelfTechnology() {
    const [technologies, setTechnologies] = useState([]);
    const [stacks, setStacks] = useState([]);
    const { getApi } = UseApi();
    const {token} = useContext(UserInfoContext);
    const {Message} = UseMessage();

    useEffect(() => {
        getTechnologies();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

    const getTechnologies = () => {
        getApi(
            `${process.env.REACT_APP_API_URL}/common/technology-stack-data`, {}, { token: token },
            (response) => {
                // 成功時
                if (response.status !== "success") {
                    // error
                    alert(Message.Common.ERROR);
                    return;
                }

                setTechnologies(response.data?.technologies || []);
                setStacks(response.data?.stacks || []);
            },
            () => {}
        );
    };

    return (
        <>
            <div className='admin-page-header'>
                <PageHeader headerTitle={'自分の技術登録'} />
                <ButtonGroup gap={2}>
                    <LinkButton buttonText={'戻る'} buttonUrl={'/my-technologies'}/>
                </ButtonGroup>
            </div>
            <Box className='admin-box'>
                <AddSelfTechnologyForm 
                    technologyData={technologies}
                    stackData={stacks}
                    isEdit={false}
                />
            </Box>
        </>   
    ) 
}
